module.exports = __webpack_public_path__ + "img/greenTick.e1cc56cb.svg";